import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function AndroidAppDevelopment() {
  const faqs = [
    {
      question: "What Android technologies does Mokshiq use?",
      answer: "We develop native Android applications using Kotlin/Java as well as high-performance cross-platform apps using Flutter and React Native."
    },
    {
      question: "Will the app be published on Google Play Store?",
      answer: "Yes, our development team handles the complete Play Store publishing lifecycle, including app sign-off, privacy policy generation, and ASO optimization."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-brands fa-android me-2"></i>Mobile App Development
            </span>
            <h1 className="page_title text-white mb-3">Android Application Development</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              High-performance, secure Android mobile apps for Fintech, E-commerce, and Enterprise platforms by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Services</a></li>
              <li className="active"><a href="#!">Android App Development</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-brands fa-android text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Native Kotlin / Java</h3>
                  <p className="text-muted small">Maximum performance and direct hardware API integration for biometric and POS printing.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-mobile-retro text-primary fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Flutter Cross-Platform</h3>
                  <p className="text-muted small">Single codebase running natively on both Android and iOS with fluid 60fps UI performance.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-shield-halved text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Bank-Grade Security</h3>
                  <p className="text-muted small">Root detection, SSL pinning, AES-256 payload encryption, and obfuscated APK builds.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="Android App Development FAQs" subtitle="Frequently asked questions about Android mobile app development." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default AndroidAppDevelopment;
